<background-modal>
  <form [formGroup]="form">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-md-6">
        <h1 i18n>Sign In</h1>
        <mat-form-field appearance="fill">
          <mat-label i18n>Username</mat-label>
          <input matInput i18n-placeholder placeholder="Username" formControlName="username" #username />
          <mat-error i18n *ngIf="form.get('username')?.errors?.['required']">
            Username is required
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label i18n>Password</mat-label>
          <input type="password" [type]="hidePassword ? 'password' : 'text'" matInput i18n-placeholder
            placeholder="Password" formControlName="password" #password />
          <button mat-icon-button type='button' matSuffix (click)="hidePassword = !hidePassword"
            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
            <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error i18n *ngIf="form.get('password')?.errors?.['required']">
            Username is required
          </mat-error>
        </mat-form-field>
        <button class="btn btn-primary" [disabled]="!form.valid" i18n style="width: 100%;"
          (click)="authService.SignIn(username.value, password.value, redirectURL)"> Login
        </button>
        <div class="big-spacer">
          <a class="no_default" routerLink="/forgot-password" i18n>Forgot Password?</a>
        </div>
        <div>
          <span i18n>
            Don't have an account?
          </span>&nbsp;
          <a i18n class="no_default" routerLink="/register-user">
            Sign Up
          </a>
        </div>
        <div class="spacer">
          <a class="no_default pointer" i18n style="width: 100%;" (click)="authService.microsoftAuth()"> Admin Login
          </a>
        </div>
      </div>
    </div>
  </form>
</background-modal>